import { useRequestEvent } from "#app";
export function useSpanWrap(fetchFn, options) {
  const event = useRequestEvent();
  const tracer = event?.context?.tracer;
  const childOf = event?.context?.activeSpan;
  if (tracer && childOf) {
    if (options) {
      return tracer.trace(options.kind, { resource: options.name, type: options.kind, childOf }, fetchFn);
    } else {
      return tracer.scope().activate(childOf, fetchFn);
    }
  }
  return fetchFn();
}
